import { t } from '@lingui/core/macro';
import { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { NoddiButton, NoddiCard } from 'noddi-ui-web';
import { formatLanguageNames } from 'noddi-util';
import { useLanguageContext } from 'noddi-web';
import { toWidgetLocale } from '../../supportWidget/locale';

type Props = {
  booking: BookingRecordDetailsCustomer;
};

/**
 * The technician to contact while the job runs; the backend sets `workerContact` only then.
 * Self-contained so the booking page redesign can move it freely.
 */
export const BSlugContactCard = ({ booking }: Props) => {
  const { workerContact } = booking;
  const { currentLanguage } = useLanguageContext();

  if (workerContact) {
    const { nickname, phoneNumber, languages } = workerContact;
    const languageNames = formatLanguageNames(
      languages.map((language) => language.value),
      toWidgetLocale(currentLanguage)
    );
    return (
      <NoddiCard size='small'>
        <div className='flex items-center justify-between gap-3'>
          <div className='flex min-w-0 flex-col'>
            {/* eslint-disable-next-line noddi/no-banned-ui-terms -- customer copy keeps "technician" (docs/terminology.json) */}
            <span className='text-sm text-muted-foreground'>{t`Your technician`}</span>
            <span className='font-semibold'>{nickname}</span>
            {languageNames && <span className='text-sm text-muted-foreground'>{t`Speaks ${languageNames}`}</span>}
          </div>
          {/* A call button rather than the number: the contact is for this job, not one to save. */}
          {phoneNumber && (
            <NoddiButton asChild variant='outline' size='small' startIcon='Phone' className='shrink-0'>
              <a href={`tel:${phoneNumber}`}>{t`Call`}</a>
            </NoddiButton>
          )}
        </div>
      </NoddiCard>
    );
  }

  return null;
};
